import { REVIEW_STATUS, BULK_FUNNEL_ACTIONS } from '../../../constants/reviewStatus'

export default {
  data () {
    return {
      isCallingReviewOrUnreviewFlag: false,
      showConfirmBulkActionModal: false,
      showConfirmBulkActionModalUsers: false,
      showRejectReasonModalFlag: false,
      showConfirmMixedStatusFlag: false,
      confirmMixedStatusTitle: ''
    }
  },
  computed: {
    isInExpenseSections () {
      return this.$route.name.includes('reimbursements')
    },
    BULK_FUNNEL_ACTIONS () {
      return BULK_FUNNEL_ACTIONS
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isRegular () {
      return this.$store.getters['LoginStore/isUser']
    },
    userLogged () {
      return this.$store.getters['UsersStore/userLogged']
    },
    selectedTransactions () {
      return this.$store.getters['TransactionsStore/selectedTransactions']
    },
    selectedUsers () {
      return this.$store.getters['TransactionsStore/selectedUsers']
    },
    transactionsTotalItems () {
      return this.$store.getters['TransactionsStore/totalItems']
    },
    selectedTransactionsBulkAction () {
      return this.$store.getters['TransactionsStore/selectedTransactionsBulkAction']
    },
    allSelectedTransactionsAreReviewed () {
      return this.$store.getters['TransactionsStore/allSelectedTransactionsAreReviewed']
    },
    allSelectedTransactionsAreAccounted () {
      return this.$store.getters['TransactionsStore/allSelectedTransactionsAreAccounted']
    },
    allSelectedTransactionsArePersonalExpense () {
      return this.$store.getters['TransactionsStore/allSelectedTransactionsArePersonalExpense']
    },
    allSelectedTransactionsAreNotReviewed () {
      return this.$store.getters['TransactionsStore/allSelectedTransactionsAreNotReviewed']
    },
    hasMixedTransactionsStatus () {
      return this.$store.getters['TransactionsStore/hasMixedTransactionsStatus']
    },
    allSelectedTransactionsAreCancelled () {
      return this.$store.getters['TransactionsStore/allSelectedTransactionsAreCancelled']
    },
    hasAnyTransactionAwaitingReview () {
      let canReviewTransactions = this.selectedTransactions.filter(el => {
        let { reviewUserTasks } = el

        return reviewUserTasks.some(el => el.canReviewNextStep && el.pending && el.user.id === this.userLogged.id)

        // el.reviewUserTasks.filter(el => el.canReviewNextStep && el.pending && el.user.id === this.userLogged.id)
      })

      if (canReviewTransactions.length > 0) {
        return true
      }
      return false
    },
    allSelectedTransactionsAreLocked () {
      return this.$store.getters['TransactionsStore/allSelectedTransactionsAreLocked']
    },
    hasMixedLockStatus () {
      return this.$store.getters['TransactionsStore/hasMixedLockStatus']
    },
    // Mostrar bloqeuar si  hay alguna transaccion no bloqueada, si todas están bloqueadas mostrar desbloqeuar
    showLockButton () {
      return this.selectedTransactions.some(el => !el.lockedAt) || this.hasMixedTransactionsStatus
    },
    showUnlockButton () {
      return this.allSelectedTransactionsAreLocked || this.hasMixedTransactionsStatus
    },
    showReviewButton () {
      if (((this.hasMixedTransactionsStatus || this.hasAnyTransactionAwaitingReview) && !this.allSelectedTransactionsAreLocked) || this.type === 'users') {
        return true
      }
      return false
    },
    showUnreviewButton () {
      if ((this.allSelectedTransactionsAreReviewed || this.hasMixedTransactionsStatus) && !this.allSelectedTransactionsAreLocked) {
        return true
      }
      return false
    },
    showRejectButton () {
      if (this.allSelectedTransactionsAreLocked) {
        return false
      }
      if (this.hasAnyTransactionAwaitingReview) {
        return true
      }
      return (this.allSelectedTransactionsAreReviewed || this.hasMixedTransactionsStatus) && !this.allSelectedTransactionsAreLocked
    },
    showAccountButton () {
      if ((this.isAdmin || this.isBookKeeper) && (this.allSelectedTransactionsAreReviewed || this.hasMixedTransactionsStatus || this.allSelectedTransactionsArePersonalExpense) && !this.allSelectedTransactionsAreAccounted) {
        return true
      }
      return false
    }
  },
  methods: {
    async bulkAction (action) {
      await this.handleSelectedTransactionsBulkAction(action)
      this.getCurrentBudget()
    },
    getCurrentBudget () {
      this.$store.dispatch('BudgetsStore/fetchBudget', this.budgetId)
    },
    clearAll () {
      if (this.isCallingReviewOrUnreviewFlag) return
      this.$store.dispatch('TransactionsStore/clearSelectedTransactions')
      this.$store.dispatch('TransactionsStore/clearSelectedUsers')
      this.$store.dispatch('TransactionsStore/toggleSelectAll', { selectAll: false, isExportTable: this.isExportTable })
    },
    handleSelectedApprove (action) {
      this.handleSelectedUsersBulkAction(action)
    },
    handleSelectedUsersBulkAction (action) {
      this.showConfirmBulkActionModalUsers = action
    },
    setTitleMixedStatusFlag () {
      if (this.isInExpenseSections) {
        this.confirmMixedStatusTitle = this.$t(`transactions_bulk_action_name__${this.showConfirmMixedStatusFlag}`) + ' ' + this.$tc('transactions_table_total_count_and_amount_expense_type')
      } else {
        this.confirmMixedStatusTitle = this.$t(`transactions_bulk_action_name__${this.showConfirmMixedStatusFlag}`) + ' ' + this.$tc('transactions_table_total_count_and_amount_transaction_type')
      }
    },
    async handleSelectedTransactionsBulkAction (action) {
      if (this.selectedTransactionsBulkAction) {
        this.showConfirmBulkActionModal = action
      } else {
        if (this.hasMixedTransactionsStatus) {
          this.showConfirmMixedStatusFlag = action
          this.setTitleMixedStatusFlag()
          return
        }
        await this.handleSelectedTransactionAction(action)
        this.showConfirmBulkActionModal = false
      }
    },
    async handleAction (action) {
      await this.handleSelectedTransactionAction(action)
    },
    async handleSelectedTransactionAction (action) {
      if (!action) return
      this.showConfirmBulkActionModalUsers = false
      this.showConfirmBulkActionModal = false
      if (action === BULK_FUNNEL_ACTIONS.APPROVE) {
        if (this.$route.meta.users) {
          await this.approveSelectedUsers()
        } else {
          await this.approveSelectedTransactions()
        }
      }

      if (action === BULK_FUNNEL_ACTIONS.REJECT) {
        this.showRejectReasonModalFlag = true
      }

      if (action === BULK_FUNNEL_ACTIONS.LOCK) {
        await this.lockSelectedTransactions()
      }

      if (action === BULK_FUNNEL_ACTIONS.UNLOCK) {
        await this.unlockSelectedTransactions()
      }

      if (action === BULK_FUNNEL_ACTIONS.UNREVIEW) {
        await this.unreviewSelectedTransactions()
      }

      if (action === BULK_FUNNEL_ACTIONS.ACCOUNT) {
        await this.accountSelectedTransactions()
      }
    },
    async approveSelectedUsers () {
      this.isCallingReviewOrUnreviewFlag = true
      let reviewInformation = { lock: true }
      await this.$store.dispatch(
        'TransactionsStore/reviewSelectedUsers',
        reviewInformation
      ).then(async () => {
        this.$emit('fetchUserTransactions', { force: true })
      })
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async rejectSelectedUsers (rejectedReason) {
      this.isCallingReviewOrUnreviewFlag = true
      let reviewInformation = { lock: false, rejectedReason: rejectedReason }
      await this.$store.dispatch(
        'TransactionsStore/rejectSelectedUsers',
        reviewInformation
      )
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async approveSelectedTransactions () {
      this.isCallingReviewOrUnreviewFlag = true
      let reviewInformation = { lock: true }
      await this.$store.dispatch(
        'TransactionsStore/reviewSelectedTransactions',
        reviewInformation
      )
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async rejectSelectedTransactions (rejectedReason) {
      this.isCallingReviewOrUnreviewFlag = true
      let reviewInformation = { lock: false, rejectedReason: rejectedReason }
      await this.$store.dispatch(
        'TransactionsStore/rejectSelectedTransactions',
        reviewInformation
      )
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async lockSelectedTransactions () {
      this.isCallingReviewOrUnreviewFlag = true
      await this.$store.dispatch('TransactionsStore/toggleLockSelectedTransactions', true)
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async unlockSelectedTransactions () {
      this.isCallingReviewOrUnreviewFlag = true
      await this.$store.dispatch('TransactionsStore/toggleLockSelectedTransactions', false)
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async unreviewSelectedTransactions () {
      this.isCallingReviewOrUnreviewFlag = true
      let reviewInformation = { lock: false, isPersonalExpense: false }
      await this.$store.dispatch(
        'TransactionsStore/unreviewSelectedTransactions',
        reviewInformation
      )
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    async accountSelectedTransactions () {
      this.isCallingReviewOrUnreviewFlag = true
      await this.$store.dispatch('TransactionsStore/accountSelectedTransactions')
      this.isCallingReviewOrUnreviewFlag = false
      this.clearAll()
    },
    countReimbursementsByAction (action) {
      const canReviewTransaction = this.isAdmin || this.isBookKeeper || (this.isRegular && (this.userLogged.isOwnerOfAnyBudget || this.userLogged.isReviewer))

      let reimbursementsMatchingActionCounter = 0

      if (action === 'APPROVE') {
        this.selectedTransactions.forEach(el => {
          if (el.lockedAt === null) {
            if (el.reviewStatus.code !== REVIEW_STATUS.APPROVED) {
              if (el.reviewUserTasks.findIndex(el => el.canReviewNextStep && el.pending && el.user.id === this.userLogged.id) > -1) {
                reimbursementsMatchingActionCounter++
              } else {
                if (el.reviewStatus.code === REVIEW_STATUS.CANCELLED && canReviewTransaction) {
                  reimbursementsMatchingActionCounter++
                }
              }
            }
          }
        })
      }
      if (action === 'REJECT') {
        this.selectedTransactions.forEach(el => {
          if (el.lockedAt === null) {
            if (el.reviewStatus.code !== REVIEW_STATUS.CANCELLED) {
              if (el.reviewUserTasks.findIndex(el => el.canReviewNextStep && el.pending && el.user.id === this.userLogged.id) > -1) {
                reimbursementsMatchingActionCounter++
              } else {
                if (el.reviewStatus.code === REVIEW_STATUS.APPROVED && canReviewTransaction) {
                  reimbursementsMatchingActionCounter++
                }
              }
            }
          }
        })
      }
      if (action === 'LOCK') {
        reimbursementsMatchingActionCounter = this.selectedTransactions.filter(el => el.lockedAt === null).length
      }
      if (action === 'UNLOCK') {
        reimbursementsMatchingActionCounter = this.selectedTransactions.filter(el => el.lockedAt).length
      }

      if (action === 'UNREVIEW') {
        this.selectedTransactions.forEach(el => {
          if (el.lockedAt === null) {
            if (el.reviewStatus.code === REVIEW_STATUS.APPROVED && canReviewTransaction) {
              reimbursementsMatchingActionCounter++
            }
          }
        })
      }

      if (action === 'ACCOUNT') {
        this.selectedTransactions.forEach(el => {
          if (el.reviewStatus.code === REVIEW_STATUS.APPROVED || el.reviewStatus.code === REVIEW_STATUS.REJECTED) {
            reimbursementsMatchingActionCounter++
          }
        })
      }
      return reimbursementsMatchingActionCounter
    }
  }
}
